jQuery( document ).ready(function($) {

    var STOP_STATE = 'STOP_STATE', PRE_STATE = 'PRE_STATE', PLAY_STATE = 'PLAY_STATE', END_STATE = 'END_STATE'; // Game states
    var MOBILE = 'MOBILE', TABLET = 'TABLET', DESKTOP = 'DESKTOP';                                              // Game sizes
    var DAILY = 'DAILY', WEEKLY = 'WEEKLY', OCCASIONALLY = 'OCCASIONALLY';                                      // Food item eat
    var SMALL = 'small', MEDIUM = 'medium', BIG = 'big';                                                        // Food item sizes
    var ASSETS_SRC = '/wp-content/themes/5aldia/dist/images/piramide/';
    var RETURN_TIME = .5;

    var draggable_sizes = [MOBILE, TABLET];

    var game_data = (function(){
        var _this = this;
        _this.game_states = [STOP_STATE, PRE_STATE, PLAY_STATE, END_STATE];
        _this.current_game_state = STOP_STATE;
        _this.current_game_size = '';
        _this.wrapper = '';
        _this.slider_offset = 0;
        _this.breakpoints = [
            {'width':1040,  'size':DESKTOP },
            {'width':640,   'size':TABLET },
            {'width':0,     'size':MOBILE }
        ];
        _this.game_height = [
            {'height':0,    'size':DESKTOP },
            {'height':820,  'size':TABLET },
            {'height':550,  'size':MOBILE }
        ];
        _this.game_piramid_offset = [
            {'left':0,      'size':DESKTOP },
            {'left':205,    'size':TABLET },
            {'left':160,    'size':MOBILE }
        ];
        _this.food = [
            {'pic':'all',           'eat':DAILY,           'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':621,  'start_y':84,  'end_x':266,  'end_y':543 },
                    {'size': TABLET,    'start_x':0,    'start_y':40,  'end_x':271,  'end_y':562 },
                    {'size': MOBILE,    'start_x':0,    'start_y':40,  'end_x':117,  'end_y':382 }
                ]
            },
            {'pic':'arros',         'eat':DAILY,           'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':419,  'start_y':2,    'end_x':163,  'end_y':495 },
                    {'size': TABLET,    'start_x':40,   'start_y':5,    'end_x':135,  'end_y':517 },
                    {'size': MOBILE,    'start_x':30,   'start_y':5,    'end_x':61,   'end_y':360 }
                ]
            },
            {'pic':'carmels',       'eat':OCCASIONALLY,    'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':830,  'start_y':184,  'end_x':340,  'end_y':35 },
                    {'size': TABLET,    'start_x':122,  'start_y':18,   'end_x':354,  'end_y':138 },
                    {'size': MOBILE,    'start_x':102,  'start_y':18,   'end_x':184,  'end_y':149 }
                ]
            },
            {'pic':'carn-vermella', 'eat':WEEKLY,           'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':861,  'start_y':153,  'end_x':310,  'end_y':306 },
                    {'size': TABLET,    'start_x':131,  'start_y':5,    'end_x':308,  'end_y':348 },
                    {'size': MOBILE,    'start_x':81,  'start_y':5,    'end_x':140,  'end_y':258 }
                ]
            },
            {'pic':'cocacola',      'eat':OCCASIONALLY,     'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':562,  'start_y':71,   'end_x':291,  'end_y':0 },
                    {'size': TABLET,    'start_x':332,  'start_y':20,   'end_x':326,  'end_y':105 },
                    {'size': MOBILE,    'start_x':252,  'start_y':20,   'end_x':163,  'end_y':105 }
                ]
            },
            {'pic':'croisants',     'eat':OCCASIONALLY,     'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':767,  'start_y':465,  'end_x':319,  'end_y':102 },
                    {'size': TABLET,    'start_x':374,  'start_y':0,    'end_x':330,  'end_y':193 },
                    {'size': MOBILE,    'start_x':284,  'start_y':0,    'end_x':164,  'end_y':161 }
                ]
            },
            {'pic':'donut',         'eat':OCCASIONALLY,     'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':720,  'start_y':315,  'end_x':236,  'end_y':60 },
                    {'size': TABLET,    'start_x':447,  'start_y':20,   'end_x':253,  'end_y':163 },
                    {'size': MOBILE,    'start_x':337,  'start_y':20,   'end_x':120,  'end_y':144 }
                ]
            },
            {'pic':'esberginia',    'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':845,  'start_y':355,  'end_x':540,  'end_y':524 },
                    {'size': TABLET,    'start_x':530,  'start_y':-10,  'end_x':495,  'end_y':560 },
                    {'size': MOBILE,    'start_x':410,  'start_y':-10,  'end_x':277,  'end_y':371 }
                ]
            },
            {'pic':'fabes',         'eat':DAILY,            'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':980,  'start_y':378,  'end_x':60,   'end_y':582 },
                    {'size': TABLET,    'start_x':633,  'start_y':12,   'end_x':114,  'end_y':583 },
                    {'size': MOBILE,    'start_x':493,  'start_y':12,   'end_x':50,   'end_y':417 }
                ]
            },
            {'pic':'farina',        'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':439,  'start_y':113,  'end_x':-31,  'end_y':654 },
                    {'size': TABLET,    'start_x':690,  'start_y':10,   'end_x':50,   'end_y':638 },
                    {'size': MOBILE,    'start_x':520,  'start_y':10,   'end_x':-20,  'end_y':436 }
                ]
            },
            {'pic':'formatge',      'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':858,  'start_y':277,  'end_x':123,  'end_y':407 },
                    {'size': TABLET,    'start_x':770,  'start_y':20,   'end_x':153,  'end_y':450 },
                    {'size': MOBILE,    'start_x':570,  'start_y':20,   'end_x':31,   'end_y':320 }
                ]
            },
            {'pic':'iogurs',        'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':699,  'start_y':152,  'end_x':306,  'end_y':435 },
                    {'size': TABLET,    'start_x':924,  'start_y':20,   'end_x':302,  'end_y':451 },
                    {'size': MOBILE,    'start_x':690,  'start_y':20,   'end_x':142,  'end_y':332 }
                ]
            },
            {'pic':'llegums',       'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':917,  'start_y':591,  'end_x':393,  'end_y':534 },
                    {'size': TABLET,    'start_x':1000, 'start_y':20,   'end_x':396,  'end_y':522 },
                    {'size': MOBILE,    'start_x':740, 'start_y':20,   'end_x':195,  'end_y':363 }
                ]
            },
            {'pic':'llenties',      'eat':WEEKLY,           'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':618,  'start_y':244,  'end_x':217,  'end_y':310 },
                    {'size': TABLET,    'start_x':1134, 'start_y':10,   'end_x':256,  'end_y':334 },
                    {'size': MOBILE,    'start_x':860, 'start_y':10,   'end_x':119,  'end_y':264 }
                ]
            },
            {'pic':'llet',          'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':878,  'start_y':30,   'end_x':419,  'end_y':388 },
                    {'size': TABLET,    'start_x':1200, 'start_y':-10,  'end_x':388,  'end_y':412 },
                    {'size': MOBILE,    'start_x':900, 'start_y':-10,  'end_x':197,  'end_y':278 }
                ]
            },
            {'pic':'mongetes',      'eat':DAILY,            'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':747,  'start_y':640,  'end_x':572,  'end_y':659 },
                    {'size': TABLET,    'start_x':1300, 'start_y':10,   'end_x':530,  'end_y':646 },
                    {'size': MOBILE,    'start_x':980, 'start_y':10,   'end_x':298,  'end_y':444 }
                ]
            },
            {'pic':'mortadela',     'eat':OCCASIONALLY,     'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':637,  'start_y':17,   'end_x':211,  'end_y':182 },
                    {'size': TABLET,    'start_x':1390, 'start_y':30,   'end_x':250,  'end_y':256 },
                    {'size': MOBILE,    'start_x':1050, 'start_y':30,   'end_x':105,  'end_y':206 }
                ]
            },
            {'pic':'nous',          'eat':DAILY,            'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':549,  'start_y':411,  'end_x':239,  'end_y':701 },
                    {'size': TABLET,    'start_x':1450, 'start_y':40,   'end_x':313,  'end_y':646 },
                    {'size': MOBILE,    'start_x':1095, 'start_y':40,   'end_x':186,  'end_y':455 }
                ]
            },
            {'pic':'oli',           'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':848,  'start_y':603,  'end_x':144,  'end_y':612 },
                    {'size': TABLET,    'start_x':1520, 'start_y':-15,  'end_x':172,  'end_y':611 },
                    {'size': MOBILE,    'start_x':1140, 'start_y':-15,  'end_x':92,  'end_y':418 }
                ]
            },
            {'pic':'ous',           'eat':WEEKLY,           'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':635,  'start_y':365,  'end_x':288,  'end_y':287 },
                    {'size': TABLET,    'start_x':1600, 'start_y':40,   'end_x':314,  'end_y':338 },
                    {'size': MOBILE,    'start_x':1200, 'start_y':40,   'end_x':157,  'end_y':267 }
                ]
            },
            {'pic':'pa',            'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':663,  'start_y':614,  'end_x':308,  'end_y':518 },
                    {'size': TABLET,    'start_x':1660, 'start_y':30,   'end_x':298,  'end_y':533 },
                    {'size': MOBILE,    'start_x':1230, 'start_y':30,   'end_x':132,  'end_y':380 }
                ]
            },
            {'pic':'pasta',         'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':755,  'start_y':5,    'end_x':310,  'end_y':681 },
                    {'size': TABLET,    'start_x':1780, 'start_y':25,   'end_x':343,  'end_y':682 },
                    {'size': MOBILE,    'start_x':1310, 'start_y':35,   'end_x':194,  'end_y':474 }
                ]
            },
            {'pic':'pastanaga',     'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':715,  'start_y':32,   'end_x':345,  'end_y':596 },
                    {'size': TABLET,    'start_x':1870, 'start_y':0,    'end_x':313,  'end_y':574 },
                    {'size': MOBILE,    'start_x':1370, 'start_y':0,    'end_x':167,  'end_y':390 }
                ]
            },
            {'pic':'peix',          'eat':WEEKLY,           'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':578,  'start_y':84,   'end_x':128,  'end_y':231 },
                    {'size': TABLET,    'start_x':1990, 'start_y':-60,  'end_x':182,  'end_y':282 },
                    {'size': MOBILE,    'start_x':1500, 'start_y':-20,  'end_x':61,   'end_y':212 }
                ]
            },
            {'pic':'pera',          'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':972,  'start_y':487,  'end_x':450,  'end_y':622 },
                    {'size': TABLET,    'start_x':2100, 'start_y':20,   'end_x':417,  'end_y':593 },
                    {'size': MOBILE,    'start_x':1610, 'start_y':30,   'end_x':160,  'end_y':465 }
                ]
            },
            {'pic':'platan',        'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':451,  'start_y':165,  'end_x':135,  'end_y':532 },
                    {'size': TABLET,    'start_x':2160, 'start_y':20,   'end_x':163,  'end_y':551 },
                    {'size': MOBILE,    'start_x':1660, 'start_y':20,   'end_x':86,   'end_y':369 }
                ]
            },
            {'pic':'pollastre',     'eat':WEEKLY,           'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':701,  'start_y':244,  'end_x':349,  'end_y':232 },
                    {'size': TABLET,    'start_x':2270, 'start_y':30,   'end_x':358,  'end_y':303 },
                    {'size': MOBILE,    'start_x':1740, 'start_y':30,   'end_x':164,  'end_y':231 }
                ]
            },
            {'pic':'remolatxa',     'eat':DAILY,            'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':523,  'start_y':263,  'end_x':99,   'end_y':677 },
                    {'size': TABLET,    'start_x':2380, 'start_y':20,   'end_x':131,  'end_y':652 },
                    {'size': MOBILE,    'start_x':1830, 'start_y':20,   'end_x':67,  'end_y':452 }
                ]
            },
            {'pic':'salsitxes',     'eat':OCCASIONALLY,     'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':955,  'start_y':22,   'end_x':242,  'end_y':147 },
                    {'size': TABLET,    'start_x':2440, 'start_y':10,   'end_x':273,  'end_y':224 },
                    {'size': MOBILE,    'start_x':1880, 'start_y':10,   'end_x':128,  'end_y':185 }
                ]
            },
            {'pic':'sindria',       'eat':DAILY,            'size': BIG,     'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':617,  'start_y':400,  'end_x':190,  'end_y':569 },
                    {'size': TABLET,    'start_x':2500, 'start_y':0,    'end_x':202,  'end_y':583 },
                    {'size': MOBILE,    'start_x':1920, 'start_y':0,    'end_x':97,   'end_y':392 }
                ]
            },
            {'pic':'tomaquet',      'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':554,  'start_y':349,  'end_x':532,  'end_y':657 },
                    {'size': TABLET,    'start_x':2630, 'start_y':30,   'end_x':470,  'end_y':650 },
                    {'size': MOBILE,    'start_x':2040, 'start_y':30,   'end_x':245,  'end_y':414 }
                ]
            },
            {'pic':'xili',          'eat':DAILY,            'size': MEDIUM,  'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':647,  'start_y':533,  'end_x':43,   'end_y':521 },
                    {'size': TABLET,    'start_x':2680, 'start_y':20,   'end_x':198,  'end_y':524},
                    {'size': MOBILE,    'start_x':2070, 'start_y':20,   'end_x':-6,  'end_y':398}
                ]
            },
            {'pic':'xocolata',      'eat':OCCASIONALLY,     'size': SMALL,   'found':0,  'coords':[
                    {'size': DESKTOP,   'start_x':837,  'start_y':493,  'end_x':350,  'end_y':140 },
                    {'size': TABLET,    'start_x':2780, 'start_y':10,   'end_x':358,  'end_y':230 },
                    {'size': MOBILE,    'start_x':2140, 'start_y':10,   'end_x':187,  'end_y':175 }
                ]
            }
        ];
        _this.drop_areas = [
            {'eat':OCCASIONALLY,    'coords':[
                    {'size': DESKTOP, 'x':230,  'y':40,    'width': 200,   'height':200},
                    {'size': TABLET,  'x':270,  'y':143,   'width': 150,   'height':160},
                    {'size': MOBILE,  'x':140,  'y':143,   'width': 99,   'height':100}
                ]
            },
            {'eat':WEEKLY, 'coords':[
                    {'size': DESKTOP, 'x':150,  'y':270,   'width': 360,   'height':134},
                    {'size': TABLET,  'x':210,  'y':332,   'width': 284,   'height':107},
                    {'size': MOBILE,  'x':100,  'y':267,   'width': 184,   'height':69}
                ]
            },
            {'eat':DAILY, 'coords':[
                    {'size': DESKTOP, 'x':10,   'y':466,   'width': 590,   'height':250},
                    {'size': TABLET,  'x':80,   'y':466,   'width': 550,   'height':254},
                    {'size': MOBILE,  'x':22,   'y':347,   'width': 346,   'height':155}
                ]
            }
        ];

        function findFoodByName( food, name )
        {
            var food_item = _.find(food, function (o){
                return o.pic === name;
            });
            return _.cloneDeep( food_item );
        }

        function getGameHeight( size )
        {
            return _.find(_this.game_height, function(o){
                return o.size === size;
            }).height;
        }

        function getSliderOffset( size )
        {
            if( _.includes(draggable_sizes, size) ){
                return _this.slider_offset;
            }else{
                return 0;
            }
        }

        function getPiramidLeftOffset( size )
        {
            return _.find(_this.game_piramid_offset, function(o){
                return o.size === size;
            }).left;
        }

        return {
            setState: function( state ) { _this.current_game_state = state },
            getState: function(){ return _this.current_game_state },
            getBreakpoints: function(){ return _.cloneDeep( _this.breakpoints ) },
            getSize: function(){ return _this.current_game_size },
            setSize: function( size ){ _this.current_game_size = size },
            setSliderOffset: function( offset ){ _this.slider_offset = offset },
            getFood: function(){ return _.cloneDeep( _this.food ) },
            getDropAreas: function(){ return _.cloneDeep( _this.drop_areas ) },
            setWrapper: function( wrapper ){ _this.wrapper = wrapper },
            getWrapper: function(){ return _this.wrapper },
            getFoodItemStartPositionByName: function( name, size )
            {
                var food_item = findFoodByName( _this.food, name );
                var coords = _.find(food_item.coords, function(o){
                    return o.size === size;
                });

                return {
                    x: coords.start_x + getSliderOffset( size ),
                    y: coords.start_y + getGameHeight( size )
                }
            },
            getFoodItemEndPositionByName: function( name, size )
            {
                var food_item = findFoodByName( _this.food, name );
                var coords = _.find(food_item.coords, function(o){
                    return o.size === size;
                });

                var position = {
                    x: coords.end_x,
                    y: coords.end_y
                };

                if( _.includes(draggable_sizes, size) === true ) {
                    var piramid_offset = $(".game_piramid").position().left - $(".game_piramid").width() + getPiramidLeftOffset( size );
                    position.x = position.x + piramid_offset;
                }

                return position;
            },
            getFoodItemAreaByName: function( name )
            {
                return findFoodByName( _this.food, name ).eat;
            },
            setFoundByName: function( name)
            {
                var food_item =_.find(_this.food, function (o){
                    return o.pic === name;
                });
                food_item.found = 1;
            },
            updateGameStatus: function( callback_function )
            {
                var total_food_items = _.size(_this.food);
                var found_food_items = _.size( _.filter(_this.food, function(o){ return o.found }) );

                if(total_food_items === found_food_items)
                    _this.current_game_state = END_STATE;

                if(total_food_items > found_food_items && found_food_items > 0)
                    _this.current_game_state = PLAY_STATE;

                if(found_food_items === 0)
                    _this.current_game_state = PRE_STATE;

                if( callback_function )
                    callback_function();
            },
            resetGameData: function()
            {
                _.forEach(_this.food, function(value){
                   value.found = 0;
                });
            }
        }
    })();

    $(window).resize(function(){
        check_window_width();
        reposition_food(game_data.getFood(), game_data.getSize());
    });

    function check_window_width()
    {
        var game_size = getBreakpointSizeFromWindowSize( $(window).width(), game_data.getBreakpoints() );
        if( game_data.getSize() === '' || game_data.getSize() !== game_size) {
            initGame("#game_wrapper", game_size);
            $('#result_pyramid').hide();
        }
    }

    function reposition_food(food, size)
    {
        var positioned_food = _.filter(food, function(o){
           return o.found === 1;
        });

        _.forEach(positioned_food, function(value){
            var coords = game_data.getFoodItemEndPositionByName(value.pic, size);
            $('.game_food_item[data-name="' + value.pic + '"]').css("left", coords.x);
        });
    }

    function initGame( selector, game_size )
    {
        game_data.resetGameData();
        game_data.setState( PRE_STATE );
        game_data.setWrapper( selector );
        game_data.setSize( game_size );

        var size = game_data.getSize();
        var wrapper = game_data.getWrapper();

        $(selector).removeClass()
                   .addClass( game_size );

        drawPiramid( wrapper, size );
        drawDropAreas( wrapper, game_data.getDropAreas(), size );
        drawFoodContainer( wrapper, size );
        drawFood( wrapper, game_data.getFood(), size );
        makeFoodBackground( '.game_food_item' );
        makeFoodDraggable( '.game_food_item' );
        if( _.includes(draggable_sizes, size) === true ) {
            makeFoodContainerDraggable('.game_food_slider');
        }
    }

    function drawFoodContainer( wrapper, size)
    {
        $(".game_food_slider, .game_food_slider_container").detach();

        if( _.includes(draggable_sizes, size) ){
            var div = '<div class="game_food_slider ' + size + '"></div>';
            $(wrapper).append( div );
        }
    }

    function getBreakpointSizeFromWindowSize( window_size, breakpoints)
    {
        var size = _.find(breakpoints, function(o){
            return o.width < window_size;
        });
        return size.size;
    }

    function drawPiramid( wrapper, size )
    {
        $(".game_piramid_mockup,.game_piramid_mockup2,.game_piramid,.game_piramid_txts").detach();

        var img = '<img src="' + ASSETS_SRC + 'piramide.png" class="game_piramid ' + size + '">';
        var txts = '<img src="' + ASSETS_SRC + language_site + '/piramide_txts.png" class="game_piramid_txts ' + size + '">';
        $(wrapper).append( img );
        $(wrapper).append( txts );
    }

    function drawDropAreas( wrapper, drop_areas, size )
    {
        $(".game_drop_area").detach();

        _.forEach(drop_areas, function(value){
            var coords = _.find(value.coords, function(o){
               return o.size === size;
            });
            var div =   '<div ' +
                        'data-eat="'+ value.eat + '" '+
                        'class="game_drop_area ' +
                        size + '" ' +
                        'style="top: ' + coords.y + 'px;' +
                        'left:'  + coords.x + 'px;' +
                        'width:'  + coords.width + 'px;' +
                        'height:'  + coords.height + 'px;' +
                        '"></div>';

            $(wrapper).append( div );
        });
    }

    function drawFood( wrapper, food, size )
    {
        $(".game_food_item").detach();

        _.forEach(food, function(value) {
            var coords = game_data.getFoodItemStartPositionByName( value.pic, size );
            var img =   '<img src="' + ASSETS_SRC + language_site + '/' + value.pic + '.png" ' +
                        'data-name="'+ value.pic + '" '+
                        'class="game_food_item ' +
                        value.size + ' ' +
                        size + '" ' +
                        'style="top: ' + coords.y + 'px;' +
                              'left:'  + coords.x + 'px;' +
                        '">';

            $(wrapper).append( img );
        });
    }

    function makeFoodDraggable( food_selector )
    {
        if($(food_selector).is(".ui-draggable")) {
            $(food_selector).draggable('destroy');
        }

        $(food_selector).draggable({
            containment: game_data.getWrapper(),
            start: function(){
                $(food_selector).removeClass("game_on_top");
                $(this).addClass("game_on_top").addClass("dragging");
            },
            stop: function(){
                $(".game_food_item").removeClass("game_on_top")
                    .removeClass("animated")
                    .removeClass("dragging");

                var drop_area = false;
                var item_position = $(this).offset();
                item_position.top += $(this).height() / 2;
                item_position.left += $(this).width() / 2;
                $(".game_drop_area").each(function(){
                    var pos = $(this).offset();
                    var area = {
                        top: pos.top,
                        left: pos.left,
                        width: $(this).width(),
                        height: $(this).height()
                    };
                    if( checkIfInterseccion(item_position, area) ){
                        drop_area = $(this).data('eat');
                    }
                });

                if( drop_area === game_data.getFoodItemAreaByName( $(this).data('name') ) ){
                    gotoDestiny( this, game_data.getSize(), function(){
                        game_data.setFoundByName( $(this.target).data('name') );
                        game_data.updateGameStatus();
                        $(this.target).removeClass("game_on_top")
                            .removeClass("animated")
                            .removeClass("dragging")
                            .addClass("found")
                            .draggable( "destroy" );

                        if(game_data.getState() == END_STATE){
                            setTimeout(function(){$('#result_pyramid').fadeIn();}, 1000);
                        }
                    });
                }else{
                    gotoOrigin( this, game_data.getSize(), function(){
                        $(".game_food_item").removeClass("game_on_top")
                                            .removeClass("animated")
                                            .removeClass("dragging");
                    });
                }
            }
        });
    }

    function makeFoodContainerDraggable( slider_selector )
    {
        if($(slider_selector).is(".ui-draggable") === true) {
            $(slider_selector).draggable('destroy');
        }

        $(slider_selector).css("left",0);
        updateFoodContainerChildrenPosition(slider_selector);

        $(slider_selector).draggable({
            axis: "x",
            containment: "slider_selector" + "_container",
            drag: function(){
                updateFoodContainerChildrenPosition(this);
            },
            stop: function(){
                var pos = $(this).position().left;
                if(pos > 20){
                    TweenLite.to($(this), RETURN_TIME, {left:20, ease: Back.easeOut, onUpdate:updateFoodContainerChildrenPosition, onUpdateParams:[slider_selector]});
                }
                var limit = ($(this).width() + 20 - $(window).width()) * -1;
                if(pos < limit){
                    TweenLite.to($(this), RETURN_TIME, {left:limit, ease: Back.easeOut, onUpdate:updateFoodContainerChildrenPosition, onUpdateParams:[slider_selector]});
                }
            }
        });
    }

    function updateFoodContainerChildrenPosition(slider_selector)
    {
        game_data.setSliderOffset( $(slider_selector).position().left );

        $(".game_food_item,.game_food_background").not(".found").each(function(){
            var coords = game_data.getFoodItemStartPositionByName( $(this).data('name'), game_data.getSize() );
            $(this).css("left", coords.x);
        });
    }

    function checkIfInterseccion(item, area)
    {
        return _.inRange( item.left, area.left, area.left + area.width )
               &&
               _.inRange( item.top, area.top, area.top + area.height )
    }

    function gotoOrigin( item, size, callback_function )
    {
        $(item).addClass("animated").removeClass("dragging");
        var start_position = game_data.getFoodItemStartPositionByName( $(item).data('name'), size);
        TweenLite.to(item, RETURN_TIME, {left:start_position.x, top:start_position.y, ease: Back.easeOut, onComplete:callback_function});
    }

    function gotoDestiny( item, size, callback_function )
    {
        $(item).addClass("animated").removeClass("dragging");
        var end_position = game_data.getFoodItemEndPositionByName( $(item).data('name'), size);
        TweenLite.to(item, RETURN_TIME, {left:end_position.x, top:end_position.y, ease: Back.easeOut, onComplete:callback_function});
    }

    function makeFoodBackground( food_selector )
    {
        $(".game_food_background").detach();

        $(food_selector).each(function(){
            var cloned_item = $(this).clone(false);
            cloned_item.removeClass("game_food_item").addClass("game_food_background");
            $(this).after(cloned_item);
        });

    }

    check_window_width();

});
